import usePermission from "../../Core/hooks/usePermission";
import { PERMISSIONS } from "../Login/constants";

const useHeaderItems = () => {
  const data = [
    {
      id: 1,
      padding: "filter",
      width: "settingsDriversTab",
      text: "USSD",
      hasPermission: true,
    },
    {
      id: 2,
      padding: "filter",
      width: "settingsDriversTab",
      text: "Rentals",
      hasPermission: usePermission([
        PERMISSIONS.RENTAL_VIEW,
        PERMISSIONS.RENTAL_VIEW_AND_EDIT,
      ]),
    },
  ];

  return data;
};

export default useHeaderItems;
